import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import QuizList from './pages/QuizList';
import QuizBuilder from './pages/QuizBuilder';
import QuizResults from './pages/QuizResults';
import UserManagement from './pages/UserManagement';
import CategoryManagement from './pages/CategoryManagement';
import SessionList from './pages/SessionList';
import SessionDetail from './pages/SessionDetail';
import Results from './pages/Results';
import TakeExam from './pages/TakeExam';
import ExamPage from './pages/ExamPage';
import ExamResult from './pages/ExamResult';
import AttendanceList from './pages/AttendanceList';
import AttendanceDetail from './pages/AttendanceDetail';
import MarkAttendance from './pages/MarkAttendance';
import TrainingDetail from './pages/TrainingDetail';
import FeedbackList from './pages/FeedbackList';
import FeedbackDetail from './pages/FeedbackDetail';
import PublicFeedback from './pages/PublicFeedback';
import Certificates from './pages/Certificates';
import CertificateBatch from './pages/CertificateBatch';
import VerifyCertificate from './pages/VerifyCertificate';
import Layout from './components/Layout';

// Protected Route Component
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/exam" element={<TakeExam />} />
          <Route path="/exam/:attemptId" element={<ExamPage />} />
          <Route path="/exam/result/:attemptId" element={<ExamResult />} />
          <Route path="/attend/:token" element={<MarkAttendance />} />
          <Route path="/f/:token" element={<PublicFeedback />} />
          <Route path="/verify" element={<VerifyCertificate />} />
          <Route path="/verify/:number" element={<VerifyCertificate />} />

          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="quizzes" element={<QuizList />} />
            <Route path="quizzes/new" element={<QuizBuilder />} />
            <Route path="quizzes/:id" element={<QuizBuilder />} />
            <Route path="quizzes/:id/results" element={<QuizResults />} />
            <Route path="sessions" element={<SessionList />} />
            <Route path="sessions/:id" element={<SessionDetail />} />
            <Route path="results" element={<Results />} />
            <Route path="attendance" element={<AttendanceList />} />
            <Route path="attendance/trainings/:tid" element={<TrainingDetail />} />
            <Route path="attendance/:id" element={<AttendanceDetail />} />
            <Route path="feedback" element={<FeedbackList />} />
            <Route path="feedback/:id" element={<FeedbackDetail />} />
            <Route path="certificates" element={<Certificates />} />
            <Route path="certificates/batches/:id" element={<CertificateBatch />} />
            <Route path="users" element={
              <ProtectedRoute adminOnly>
                <UserManagement />
              </ProtectedRoute>
            } />
            <Route path="categories" element={
              <ProtectedRoute adminOnly>
                <CategoryManagement />
              </ProtectedRoute>
            } />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
